import classNames from "classnames";

type LabelItem = {
  value: string;
  className?: string;
  testId?: string;
};

type RainLabelProps = {
  topLabel: LabelItem;
  bottomLabel: LabelItem;
};

export const BARS_LABEL_HEIGHT = 52;

export const BarsLabel = ({ topLabel, bottomLabel }: RainLabelProps) => {
  return (
    <div className="m:flex m:flex-col m:items-center m:pt-1 m:pb-2 m:text-base m:text-blue-950 m:dark:text-neutral-white">
      <div
        className={classNames(
          "m:mt-1 m:h-4 m:leading-3 m:font-bold",
          topLabel.className,
        )}
        data-testid={topLabel.testId ?? ""}>
        {topLabel.value}
      </div>
      <div
        className={classNames("m:leading-3", bottomLabel.className)}
        data-testid={bottomLabel.testId ?? ""}>
        {bottomLabel.value}
      </div>
    </div>
  );
};
